import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { Link } from "react-router-dom";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { updateMeta } from "../../store/actions/metaAction";
import { useDispatch } from "react-redux";
import server from "../../api/server";

const HeroSectionIndex = () => {
	const [loading, setLoading] = useState(true);
	const [data, setData] = useState([]);
	const dispatch = useDispatch();

	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "الرايات الترحيبية",
				breadcrumb: "راية ترحيبية",
				button: {
					show: true,
					text: "اضافة راية ترحيبية جديدة",
					link: "/siteinfo/heroSection/create",
				},
			})
		);
		try {
			const pageData = await server(cookie).get("/pages/hero-section/sections");
			setData(pageData.data.data.sections);

			setLoading(false);
		} catch (error) {
			toast.error("خطأ، برجاء المحاولة لاحقا!");
			setLoading(false);
		}
	};

	const handleDelete = postID => {
		axios
			.delete(
				`${process.env.REACT_APP_API_URL}/pages/hero-section/sections/${postID}`,
				{
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
					},
				}
			)
			.then(function (response) {
				onStart();
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	useEffect(() => {
		onStart();
	}, []);

	return (
		<section>
			{loading && <Loader />}
			<section>
				<div className="row">
					{data?.map(post => (
						<div className="col-md-3" key={post.slug}>
							<div className="serviceItem">
								<button onClick={() => handleDelete(post.slug)}>
									<i className="fas fa-trash"></i>
								</button>
								<Link to={`/siteinfo/heroSection/show/${post.slug}`}>
									<img
										src={`${process.env.REACT_APP_MAIN_URL}/${post.image}`}
										alt={
											post.sectionTitle?.ar ||
											post.titleObj?.ar ||
											post.title ||
											""
										}
									/>
									<h1>
										{post.sectionTitle?.ar ||
											post.titleObj?.ar ||
											post.title ||
											""}
									</h1>
									<p>{post.description?.ar || ""}</p>
								</Link>
							</div>
						</div>
					))}
				</div>
			</section>
		</section>
	);
};
export default HeroSectionIndex;
